export default "__VITE_ASSET__CrAJAXTJ__"